import { getQueryValue } from "@kivra/sdk/common";
import type { ColorScheme, Config } from "../types";
import { convertUrlParametersFromBase64 } from "./helpers";

/**
 * Funtion to get color scheme preference
 * @param href (website url)
 */
export function getColorScheme(
  config: Config,
  href: string,
): ColorScheme | undefined {
  const prefersColor = getPrefersColorScheme(
    getAndDecodeOption("prefers_color_scheme", href),
  );
  if (prefersColor) {
    return prefersColor;
  }
  const stateColor = getPrefersColorScheme(
    getStateColorScheme(config, getAndDecodeOption("state", href)),
  );
  return stateColor;
}

function getPrefersColorScheme(scheme?: string): ColorScheme | undefined {
  switch (scheme) {
    case "light":
    case "dark":
      return scheme;
    default:
      return;
  }
}

function getStateColorScheme(
  config: Config,
  stateString?: string,
): ColorScheme | undefined {
  if (!stateString) {
    return;
  }
  const { colorScheme } = convertUrlParametersFromBase64(stateString, config);
  return colorScheme;
}

function getAndDecodeOption(name: string, href: string): string | undefined {
  const value = getQueryValue(name, href);
  return value ? decodeURIComponent(value) : undefined;
}
